// extracted by mini-css-extract-plugin
export var subtitle = "_bf-2";
export var title = "_bf-0";
export var titleNoWrap = "_bf-1";